// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1ltU7","footer":"Form_footer__2sAb1"};